module.exports = __webpack_public_path__ + "static/user-list-items-do-c248ee71b2455559c78dcea1b1f89bb5.png";